import React from 'react';

import {Heading, Icon} from '@albert-io/atomic';
import type {IconProp} from '@albert-io/atomic/atoms/Icon/Icon.react';
import {ClassDetailHeader} from '../ClassDetail/ClassDetailHeader';

import {getNavScope, getNavTab} from '../Sidemenu/teacherNavScope';

// Static cross-class header; scope-neutral pages (Folders) name themselves here instead,
// while the remaining classwork pages name their own section below it.
const PageHeader = ({icon, title}: {icon?: IconProp; title: string}) => (
  <header className='border-primary p-x4 flex shrink-0 items-center border-b'>
    <Heading as='h1' className='m-x0 gap-x1-half flex items-center truncate' size='m'>
      {icon && <Icon icon={icon} iconStyle='regular' size='inherit' />}
      {title}
    </Heading>
  </header>
);

interface Props {
  pathname: string;
}

/**
 * The teacher dashboard's page header, chosen from the current nav scope: the
 * colored class banner inside a class, the page's own title on scope-neutral
 * pages (Folders), else the static "All Classwork" header.
 * New scopes/headers slot into the switch below as the dashboard grows.
 */
export const DashboardHeader = ({pathname}: Props) => {
  const scope = getNavScope(pathname);

  if (scope.kind === 'class') {
    // Keyed so a class switch resets the banner instead of showing the previous class's name/color.
    return <ClassDetailHeader classroomId={scope.classId} key={scope.classId} />;
  }

  if (getNavTab(pathname) === 'folders') {
    return <PageHeader icon='folders' title='Folders' />;
  }

  return <PageHeader title='All Classwork' />;
};
